<template>
    <div>
        <v-row justify="center">
            <v-col cols="12" sm="12" md="6" lg="3" align="center">
                <v-card elevation="0">
                    <v-card-title class="pl-10 font-weight-bold">LOGIN</v-card-title>
                    <v-card-text>
                        <v-form 
                            v-model="valid"
                            ref="form"
                        >
                            <v-row>
                                <v-text-field 
                                    prepend-icon="person"
                                    clearable
                                    name="login" 
                                    label="Usuário"
                                    type="text"
                                    v-model="user"
                                    :rules="requiredRules"
                                    outlined
                                />
                                <v-text-field
                                    prepend-icon="lock"
                                    outlined
                                    clearable
                                    name="password"
                                    label="Senha"
                                    :append-icon="$store.state.showPW ? 'visibility' : 'visibility_off'"
                                    @click:append="$store.state.showPW = !$store.state.showPW"
                                    :type="$store.state.showPW ? 'text' : 'password'"
                                    v-model="password"
                                    :rules="requiredRules"
                                    v-on:keyup.enter="login"
                                />
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-row justify="center">
                            <v-col cols="12" sm="12" md="12" align="center">
                                
                                <v-btn
                                    @click="login"
                                    rounded
                                    x-large
                                    block
                                    elevation="0"
                                    class="light-blue darken-4 white--text"
                                    type="submit"
                                ><v-icon left>mdi-login-variant</v-icon>
                                    Entrar
                                </v-btn>

                                
                            </v-col>
                        
                            <v-col cols="12" sm="12" md="12" class="d-flex justify-center py-0 px-0">
                                <v-card>
                                <v-btn 
                                    small
                                    elevation="0" 
                                    color="white secondary--text my-3" 
                                    class="btn-link" 
                                    @click="forgot">
                                        Esqueci a senha
                                </v-btn>
                                </v-card>
                                <v-card>
                                <v-btn 
                                    small
                                    elevation="0" 
                                    color="white secondary--text my-3" 
                                    class="btn-link" 
                                    @click="updatePassword"
                                    v-show="true">
                                        Alterar a senha
                                </v-btn>    
                                </v-card>                          
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>



        <v-dialog v-model="dialog" width="400">
            <v-card outlined elevation="4">
                <v-card-title>Login</v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-card-text>
                    <div class="text--primary espaco-top">
                    {{ messageDialog }}
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn text class="text-right" @click="cancel">Cancelar</v-btn>
                    <v-btn text class="text-right" @click="updatePassword">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <snackbar
            :text="snackbarMessage"
            :color="snackbarColor"
        />

        <v-dialog v-model="dialogLoginBloqueado" width="400">
            <v-card outlined elevation="4">
                <v-card-title>LOGIN BLOQUEADO</v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-card-text>
                <div class="text--primary espaco-top">
                    <a @click="forgot" class="linkTexto">Clique aqui</a> para gerar uma nova senha de acesso ou clique em "Esqueci a Senha" na tela inicial.
                </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn text class="text-right" @click="cancelLoginBlocked">Cancelar</v-btn>          
                </v-card-actions>
            </v-card>
        </v-dialog>
        <snackbar
            :text="snackbarMessage"
            :color="snackbarColor"
        />
        
        <v-dialog v-model="dialogLoginInativo" width="400">
            <v-card outlined elevation="4">
                <v-card-title>LOGIN DESATIVADO</v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-card-text>
                    <div class="text--primary espaco-top">
                       <div v-html="messageDialog"></div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn text class="text-right" @click="cancelLoginDisabled">Cancelar</v-btn>               
                </v-card-actions>
            </v-card>
        </v-dialog>
        <snackbar
            :text="snackbarMessage"
            :color="snackbarColor"
        />

    </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex';
import snackbarMixin from "../../mixins/snackbar.mixin";

export default {
    mixins: [snackbarMixin],
    name: 'Login',
    data() {
        return{
            user:'',
            password:'',
            valid: false,
            dialog: false,
            messageDialog: '',
            requiredRules: [v => !!v || 'Campo obrigatório'],
            dialogLoginBloqueado:'',
            dialogLoginInativo:'',
        }
    },
    mounted(){
        this.logout();
        this.updateIsLoginPage(true);
        this.updatePreviousPage('login');
    },
    computed: {
        ...mapGetters('login', ['isLoginPage']),
    },
    methods:{
        ...mapMutations('users', ['updateLogin']),
        ...mapMutations('common', ['updateSourceSearch','updateRequestingAgency','updateEnabledReordering','updateSourceSearchSelected', 'updatePreviousPage']),
        ...mapMutations('login', ['updateIsLoginPage']),
        login() {
            if(this.$refs.form.validate())
            {
                this.logout();
                this.$store.dispatch('login/login', {
                    username: this.user,
                    password: this.password
                })
                .then((result) => {
                    if(result.Status == "OK"){
                        if (this.$store.state.login.accessValid) {
                            this.setSourceSearch();
                            this.$router.push({ name : 'ListRequest' });
                        }
                    } else {
                        this.messageDialog = result.Mensagem;
                        this.dialog = false;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        if(error.response.status == 400) {
                            var msgErro = error.response.data.error;
                            
                            //localiza a palavra para identificar primeiro acesso ou senha expirada
                            if(msgErro.indexOf('expirada') !== -1){
                                this.messageDialog = msgErro;
                                this.dialog =true;
                                
                            } else if (msgErro.indexOf('Operador desativado') !== -1){

                                this.messageDialog = msgErro;
                                this.dialogLoginInativo = true;
                            }
                            else if (msgErro.indexOf('login bloqueado') !== -1){
                                this.messageDialog = msgErro;
                                this.dialogLoginBloqueado = true;
                            }
                            else
                            {
                                this.showSnackbar(msgErro, 'error');
                            }
                        } else{
                            this.showSnackbar('Não foi possível fazer o login no momento.', 'error');
                        }
                    } else {
                        this.showSnackbar('Não foi possível fazer o login no momento.', 'error');
                    }
                });
            }
        },
        logout() {
            this.$store.dispatch('login/logout');
            this.$store.dispatch('request/clearListRequest');
            this.$store.state.request.list = [];
        },
        forgot(){
            this.$router.push({ name : 'ResetPasswordMail' });
        },       
        updatePassword(){
            this.dialog=false;
            this.updateLogin(this.user);

            this.$router.push({ name : 'Profile' });
        },
        updatePasswordBloqueado(){
            //this.dialog=false;
            this.updateLogin(this.user);

            this.$router.push({ name : 'Profile' }).catch(()=>{this.$forceUpdate()});
        },
        loginBlocked()
        {
            this.dialog=false;
            this.updateLogin(this.user);
            this.$router.push({ name : 'Profile' });
        },
        cancel(){
            this.dialog=false;
        },
        cancelLoginBlocked(){
            this.dialogLoginBloqueado=false;
        },
        cancelLoginDisabled(){
            this.dialogLoginInativo=false;
        },
        setSourceSearch(){
            let lstAgencies = this.$store.state.login.associatedAgencies;

            if(lstAgencies != null && lstAgencies != undefined && lstAgencies.length == 1)
            {
                let arrValue = lstAgencies[0].value.split('|');

                this.updateSourceSearch(arrValue[0]);
                this.updateRequestingAgency((arrValue[1] == "-1" || arrValue[1] === "-1") ? null : arrValue[1]);
                this.updateEnabledReordering(this.isTrueValue(arrValue[2]), this.isTrueValue(arrValue[4]));
                this.updateSourceSearchSelected(lstAgencies[0].value);
            }
        },
        isTrueValue(value){
            let isTrue = ((value != undefined) && (value.toLowerCase() == "true" || value == "1" || value == true || value === 1));
            return isTrue;
        },                
    }
}
</script>
<style scoped>
.title{
    background-color: #EFEFEF;
}
.espaco-top {
    padding-top: 10px;
}
.v-sheet.v-card {
  box-shadow: none !important;
  border-radius: 0 !important;
}
.linkTexto
{
    text-decoration: underline;
}
</style>